import { request } from "../utils";
import { apis } from "../constants";

export const searchTask = (params: Partial<SearchTaskParams>) => {
    return request<PagedData<TaskRecord>>(apis.searchTask, {
        method: 'post', data: params
    })
}

export const closeTask = (id: any) => {
    return request(apis.closeTask, {
        method: 'post', data: {
            taskIds: [id]
        }
    })
}

export const assignTask = (userId: any, taskId: any) => {
    return request(apis.assignTask, {
        method: 'post', data: { userId: userId - 0, taskId: taskId - 0  }
    })
}

export const batchComplete = (taskIds: any[]) => {
    return request(apis.completeTask, {
        method: 'post', data: {
            taskIds: taskIds
        }
    })
}